import { Action } from '@ngrx/store';

export class StocksMarketAction implements Action {

    public static marketOpen: string = '[Stocks Market] market_open';
    public static marketClosed: string = '[Stocks Market] market_closed';

    public static getMarketStatus = '[Stocks Market] get_market_status';
    public static getMarketStatusError = '[Stocks Market] get_market_status_error';
    public static getMarketStatusSuccess = '[Stocks Market] get_market_status_success';

    public static getInstrumentInfo = '[Stocks Market] get_instrument_info';
    public static gettingInstrumentInfo = '[Stocks Market] getting_instrument_info';
    public static getInstrumentInfoError = '[Stocks Market] get_instrument_info_error';
    public static getInstrumentInfoSuccess = '[Stocks Market] get_instrument_info_success';

    public static getInstrumentsInfoByArray = '[Stocks Market] get_instrument_info_by_array';
    public static gettingInstrumentsArrayInfo = '[Stocks Market] getting_instruments_info_array';
    public static getInstrumentsInfoByArrayError = '[Stocks Market] get_instrument_info_by_array_error';
    public static getInstrumentsInfoByArraySuccess = '[Stocks Market] get_instrument_info_by_array_success';

    public static getTrends = '[Stocks Market] get_trends';
    public static getTrendsError = '[Stocks Market] get_trends_error';
    public static getTrendsSuccess = '[Stocks Market] get_trends_success';

    public static unsubscribeTrends = '[Stocks Market] unsubscribe_trends';
    public static unsubscribeTrendsError = '[Stocks Market] unsubscribe_trends_error';
    public static unsubscribeTrendsSuccess = '[Stocks Market] unsubscribe_trends_success';

    public static getQuote = '[Stocks Market] get_quote';
    public static getQuoteError = '[Stocks Market] get_quote_error';
    public static getQuoteSuccess = '[Stocks Market] get_quote_success';

    public static unsubscribeQuotes = '[Stocks Market] unsubscribe_quotes';
    public static unsubscribeQuotesError = '[Stocks Market] unsubscribe_quotes_error';
    public static unsubscribeQuotesSuccess = '[Stocks Market] unsubscribe_quotes_success';

    public static getQuoteInfo = '[Stocks Market] get_quote_info';
    public static gettingQuoteInfo = '[Stocks Market] getting_quote_info';
    public static getQuoteInfoError = '[Stocks Market] get_quote_info_error';
    public static getQuoteInfoSuccess = '[Stocks Market] get_quote_info_success';

    public static getLastHourHistory = '[Stocks Market] get_last_hour_history';
    public static getLastHourHistoryError = '[Stocks Market] get_last_hour_history_error';
    public static getLastHourHistorySuccess = '[Stocks Market] get_last_hour_history_success';

    public static getLastDayHistory = '[Stocks Market] get_last_day_history';
    public static getLastDayHistoryError = '[Stocks Market] get_last_day_history_error';
    public static getLastDayHistorySuccess = '[Stocks Market] get_last_day_history_success';

    public static getLastWeekHistory = '[Stocks Market] get_last_week_history';
    public static getLastWeekHistoryError = '[Stocks Market] get_last_week_history_error';
    public static getLastWeekHistorySuccess = '[Stocks Market] get_last_week_history_success';

    public static getLastMonthHistory = '[Stocks Market] get_last_month_history';
    public static getLastMonthHistoryError = '[Stocks Market] get_last_month_history_error';
    public static getLastMonthHistorySuccess = '[Stocks Market] get_last_month_history_success';

    public static getLastTwoMonthsHistory = '[Stocks Market] get_last_two_months_history';
    public static getLastTwoMonthsHistoryError = '[Stocks Market] get_last_two_months_history_error';
    public static getLastTwoMonthsHistorySuccess = '[Stocks Market] get_last_two_months_history_success';

    public static getLastYearHistory = '[Stocks Market] get_last_year_history';
    public static getLastYearHistoryError = '[Stocks Market] get_last_year_history_error';
    public static getLastYearHistorySuccess = '[Stocks Market] get_last_year_history_success';

    public static getLastFiveYearsHistory = '[Stocks Market] get_last_five_years_history';
    public static getLastFiveYearsHistoryError = '[Stocks Market] get_last_five_years_history_error';
    public static getLastFiveYearsHistorySuccess = '[Stocks Market] get_last_five_years_history_success';

    public static getQuoteHistory = '[Stocks Market] get_quote_history';
    public static getQuoteHistoryError = '[Stocks Market] get_quote_history_error';
    public static getQuoteHistorySuccess = '[Stocks Market] get_quote_history_success';

    public static resetQuoteHistoryState = '[Stocks Market] reset_quote_history_state';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
